<template>
  <div>
    <div class="form-item mb24">
      <div class="addresses" v-if="isLoad">
        <div
          v-for="(item, index) in addresses"
          :key="item.id"
          class="address"
          :class="{
            address_active: item.default,
          }"
        >
          <div class="address__left">
            <div
              class="address__circle"
              :class="{
                address__circle_active: item.default,
              }"
              :ref="`address-circle-${index + 1}`"
              @click="makeActive(index + 1)"
            >
              <span></span>
            </div>
            <p class="address__text">
              {{ item.street }} {{ item.house }}, {{ item.postcode || "" }},
              {{ item.city }}
            </p>
          </div>

          <div class="address__actions">
            <img
              class="address__edit"
              src="@/assets/images/editIcon.svg"
              alt=""
              @click="editAddress(item)"
            />
            <img
              class="address__delete"
              src="@/assets/images/deleteIcon.svg"
              alt=""
              @click="toggleDeleteModal(item.id)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="form-item mb24">
      <button type="reset" @click="openModal" class="btn btn_address">
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.60052 2.00712V11.9931"
            stroke="#F07300"
            stroke-width="2.08267"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.449 7.10064H1.55127"
            stroke="#F07300"
            stroke-width="2.08267"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <span> {{ $t("forms.addAddress") }}</span>
      </button>
    </div>

    <main-modal :show="show" @close="toggleModal" :className="`address-modal`">
      <add-address @close="toggleModal" />
    </main-modal>

    <main-modal
      :show="showDeleteModal"
      :className="'delete-modal'"
      @close="toggleDeleteModal"
    >
      <delete-modal @close="toggleDeleteModal" @accept="remove" />
    </main-modal>
  </div>
</template>

<script>
import addAddress from "@/components/modals/address/addAddress";
import mainModal from "@/components/modals/mainModal";
import deleteModal from "@/components/modals/delete/index";

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "app-addresses",
  components: {
    addAddress,
    mainModal,
    deleteModal,
  },
  computed: {
    ...mapGetters({
      show: "address/show",
      addresses: "address/addresses",
    }),
  },
  data() {
    return {
      isLoad: false,
      showDeleteModal: false,
    };
  },
  methods: {
    ...mapMutations({
      setState: "address/setState",
    }),
    ...mapActions({
      fetch: "address/fetch",
      delete: "address/delete",
      setDefault: "address/setDefault",
    }),
    toggleModal() {
      this.setState({
        key: "show",
        value: !this.show,
      });
    },
    setType(value) {
      this.setState({
        key: "type",
        value,
      });
    },
    openModal() {
      this.setType("add");
      this.setState({
        key: "address",
        value: {
          street: "",
          house: "",
        },
      });

      window.scrollTo({ top: 0, behavior: "smooth" });
      this.toggleModal();
    },
    editAddress(item) {
      this.setState({
        key: "address",
        value: item,
      });

      this.setType("edit");
      this.toggleModal();

      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    async deleteAddress(id) {
      try {
        await this.delete(id);
        await this.fetch();
      } catch (err) {}
    },
    async makeActive(id) {
      const elements = document.querySelectorAll(".address__circle");
      elements.forEach((element) => {
        element.classList.remove("address__circle_active");
      });

      const active = this.$refs[`address-circle-${id}`][0];
      active.classList.add("address__circle_active");

      const addressId = this.addresses[id - 1].id;
      const mutatedAddresses = this.addresses.map((item, index) => {
        item.default = false;

        if (index == id - 1) {
          item.default = true;
        }

        return item;
      });

      this.setState({
        key: "addresses",
        value: mutatedAddresses,
      });

      await this.setDefault(addressId);
      await this.fetch();
    },
    toggleDeleteModal(id = null) {
      if (id) {
        this.deleteId = id;
      } else {
        this.deleteId = null;
      }

      this.showDeleteModal = !this.showDeleteModal;
    },
    async remove() {
      this.deleteAddress(this.deleteId);
      this.toggleDeleteModal();
      this.$log("profile_address_remove");
    },
  },
  async created() {
    this.isLoad = true;
  },
};
</script>

<style lang="scss" scoped>
.addresses {
  box-shadow: 0px 10px 20px rgba(155, 205, 130, 0.2);
  background: linear-gradient(
      0deg,
      rgba(155, 205, 130, 0.2),
      rgba(155, 205, 130, 0.2)
    ),
    #ffffff;
}

.address {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  height: 48px;
  background-color: #fff;

  &:not(:last-child) {
    margin-bottom: 6px;
  }

  &_active {
    box-shadow: unset;
    background: linear-gradient(
        0deg,
        rgba(155, 205, 130, 0.2),
        rgba(155, 205, 130, 0.2)
      ),
      #ffffff;
  }

  &__left,
  &__right {
    display: flex;
    align-items: center;
  }

  &__icon {
    margin-right: 16px;
  }

  &__actions {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  &__delete {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  &__edit {
    width: 24px;
    height: 24px;
    margin-right: 16px;
    cursor: pointer;
  }

  &__text {
    width: 100%;
  }

  &__circle {
    width: 20px;
    height: 20px;
    border: 2px solid #9bcd82;
    border-radius: 50%;
    margin-right: 16px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    &_active {
      span {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #9bcd82;
      }
    }
  }
}

@media (max-width: 768px) {
  .address {
    height: auto !important;
  }
}
</style>
